/* wsapi3-checkout-header v1.0 */
/* Deploy Version 2026-09-16 11:27:33 */
/* Deploy Version 2026-07-27 16:11:02 */
wsMain.createModule({
  name: "checkout-cart-header",
  version: '1.0',
  updatedAt: '2026-07-14',
  function: 'get',
  subFunctions: {
    progressBar() {
      try {
        const objEtapa = {
            "carrinho": 0,
            "IDENTIFICACAO": 34,
            "FORMAS_PAGAMENTO": 67,
            "FinalPagamento": 100
        }

        const subEtapa = document.querySelector('#HdSubEtapaLoja')
        const etapa = document.querySelector('#HdEtapaLoja').value

        let width
        if (subEtapa) {
            width = objEtapa[subEtapa.value] ? objEtapa[subEtapa.value] : 0
        } else {
            width = objEtapa[etapa] ? objEtapa[etapa] : 0
        }

        const barras = document.querySelectorAll('.progresso-barra .progresso-barra__conteudo')
        barras.forEach(barra => {
            barra.style.width = width + '%'
        })

        const bolinha0 = document.querySelectorAll('.progresso:nth-child(1) .bolinha')
        const bolinha1 = document.querySelectorAll('.progresso:nth-child(2) .bolinha')
        const bolinha2 = document.querySelectorAll('.progresso:nth-child(3) .bolinha')
        const todasBolinhas = document.querySelectorAll('.progresso .bolinha')

        // Reseta antes de recalcular — progressBar() pode ser chamado mais de uma vez
        // na mesma página (ex.: checkout-payment-page atualiza a "sub-etapa" ao sair da
        // tela de identificação sem reload), então precisa ser idempotente.
        todasBolinhas.forEach(b => {
            b.classList.remove('bolinhaActive', 'bolinhaMainActive')
        })

        if (width < 32) {
            bolinha0.forEach(b0 => {
                b0.classList.add('bolinhaActive')
                b0.classList.add('bolinhaMainActive')
            })
        } else {
            // Carrinho já foi concluído (etapa atual é posterior) — antes disso vinha
            // marcado por padrão direto no HTML estático; como agora resetamos todas
            // as bolinhas antes de recalcular, precisa ser reafirmado aqui também.
            bolinha0.forEach(b0 => {
                b0.classList.add('bolinhaActive')
            })
        }

        if (width >= 32) {
            bolinha1.forEach(b1 => {
                b1.classList.add('bolinhaActive')
                if (width < 67) {
                    b1.classList.add('bolinhaMainActive')
                }
            })
        }

        if (width >= 67) {
            bolinha1.forEach(b1 => {
                b1.classList.add('bolinhaActive')
            })
            bolinha2.forEach(b2 => {
                b2.classList.add('bolinhaActive')
                if (width < 100) {
                    b2.classList.add('bolinhaMainActive')
                }
            })
        }

        if (width >= 100) {
            todasBolinhas.forEach(b => {
                b.classList.add('bolinhaActive')
            })
        }
      } catch (error) {
          console.log("test ~ progressBar ~ error:", error)
      }
    },
  },
  async get() {
      try {
        wsMain.modules['checkout-cart-header'].subFunctions.progressBar()
        
        console.log('modulo checkout-cart-header 17-01-25')
        return true
      } catch (error) {
          console.log("test ~ get ~ error:", error)
          return false
      }
  }
})
